
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paths/[slug]",
      function () {
        return require("private-next-pages/paths/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paths/[slug]"])
      });
    }
  